import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Printer, Download } from "lucide-react";
import { useT } from "@/lib/i18n";
import { Modal, Btn } from "@/components/ui-kit";

export function StaffQrModal({ member, onClose }) {
  const { t } = useT();
  const ref = useRef(null);
  if (!member) return null;
  const url = `${window.location.origin}/login?code=${encodeURIComponent(member.access_code)}`;
  const download = () => {
    const c = ref.current?.querySelector("canvas"); if (!c) return;
    const a = document.createElement("a"); a.href = c.toDataURL("image/png"); a.download = `qr_${member.access_code}.png`; a.click();
  };
  const print = () => {
    const c = ref.current?.querySelector("canvas"); if (!c) return;
    const w = window.open("", "_blank");
    w.document.write(`<html><body style="font-family:sans-serif;text-align:center;padding:40px"><h2>${member.name}</h2><img src="${c.toDataURL("image/png")}" width="320"/><p style="font-family:monospace;font-size:24px;font-weight:bold;letter-spacing:3px">${member.access_code}</p><p>${t("qr_print_hint")}</p><script>window.onload=()=>{window.print();window.close();}</script></body></html>`);
    w.document.close();
  };
  return (
    <Modal open={!!member} onClose={onClose} title={`QR · ${member.name}`}>
      <div className="text-center" data-testid="staff-qr-modal">
        <p className="text-sm text-slate-600">{t("qr_hint")}</p>
        <div ref={ref} className="mx-auto mt-4 inline-block rounded-2xl border border-slate-200 bg-white p-4"><QRCodeCanvas value={url} size={240} level="M" includeMargin={false} /></div>
        <p data-testid="staff-qr-code" className="mt-3 font-mono text-xl font-extrabold tracking-widest">{member.access_code}</p>
        <div className="mt-5 flex justify-center gap-2">
          <Btn variant="outline" data-testid="staff-qr-download" onClick={download}><Download size={14} />{t("download")}</Btn>
          <Btn data-testid="staff-qr-print" onClick={print}><Printer size={14} />{t("print_qr")}</Btn>
        </div>
      </div>
    </Modal>
  );
}
